import axios from 'axios';

/**
 * Axios instance for public API calls - NO authentication required
 */
const publicAxiosInstance = axios.create({
    baseURL: '/rapidcraft-service/api/rapidcraft/public',
});

export interface PublicProjectResponse {
    status: string;
    code: number;
    resultObject: {
        chatSessionId: number;
        commitId: string;
        files: Record<string, { code: string }>;
        designSystem: string;
        templateVersion?: string;
        sessionName?: string;
    };
    message?: string;
}

/**
 * Access a publicly shared project using publicId and token
 */
export async function getPublicProject(publicId: string, token: string): Promise<PublicProjectResponse> {
    try {
        const response = await publicAxiosInstance.get('/accessProject', {
            params: { publicId, token },
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching public project', error);
        throw error;
    }
}

export default publicAxiosInstance;
